import { useState } from 'react';
import { trackEvent } from '../firebase';

interface EmbedSnippetProps {
  projectId: string;
  cdnUrl: string;
  apiUrl: string;
  /** When true the snippet starts expanded; defaults to false (collapsed). */
  defaultExpanded?: boolean;
}

export function EmbedSnippet({
  projectId,
  cdnUrl,
  apiUrl,
  defaultExpanded = false,
}: EmbedSnippetProps) {
  const [collapsed, setCollapsed] = useState(!defaultExpanded);

  const snippet = `<script src="${cdnUrl}"></script>
<script>
  PLW.init({
    projectId: '${projectId}',
    apiUrl: '${apiUrl}',
    emailInputSelector: '#email',
    formSelector: '#waitlist-form',
  });
</script>`;

  return (
    <section className="bg-white rounded-xl p-6 mb-6 shadow-sm">
      <div className="flex justify-between items-center">
        <h3 className="text-base font-bold m-0">Embed Snippet</h3>
        <button
          onClick={() => {
            const nextCollapsed = !collapsed;
            setCollapsed(nextCollapsed);
            trackEvent('toggle_embed_snippet', { expanded: !nextCollapsed, project_id: projectId });
          }}
          className="bg-transparent border-0 cursor-pointer text-xl px-2 text-gray-500 hover:text-gray-700"
          aria-label={collapsed ? 'Expand embed snippet' : 'Collapse embed snippet'}
        >
          {collapsed ? '▶' : '▼'}
        </button>
      </div>
      {!collapsed && (
        <>
          <p className="text-sm text-gray-500 mt-3 mb-2">
            Paste this into any webpage to start collecting emails and analytics.
          </p>
          <pre className="bg-slate-800 text-slate-200 p-4 rounded-lg text-xs overflow-x-auto whitespace-pre-wrap break-all">
            {snippet}
          </pre>
        </>
      )}
    </section>
  );
}
